import { formatNumber } from '@progress/kendo-intl'

/**
 * 総数に対する集計数の比率をフォーマットします。
 *
 * @param ratio - 総数に対する集計数の比率。
 * @returns フォーマットされた文字列。
 */
export function forRatio(ratio: number): string {
  return formatNumber(ratio, 'p1')
}
